export enum ETripsEventName {
  CLAIMS_CAROUSEL_OPENED = 'Claims Carousel Opened',
  CLAIMS_CAROUSEL_VIEWED = 'Claims Carousel Viewed',
  RENTER_BOOKING_EPISODIC_UPDATED = 'Renter Booking Episodic Updated',
  SMART_MATCH_REQUEST_TO_BOOK_CLICKED = 'Smart Match Request To Book Clicked',
  SMART_MATCH_SIMILAR_SEARCH_CLICKED = 'Smart Match Similar Search Clicked',
}

export interface IClaimsCarouselViewedEventInfo {
  slideNumber: number;
}

export interface IRenterBookingEpisodicUpdatedEventInfo {
  bookingID: number;
  oldBundle: string;
  newBundle: string;
  oldCost: number;
  newCost: number;
}

export interface ISmartMatchRequestToBookClickedEventInfo {
  bidID: number;
  bidMatchID: number;
  rentalID: number;
  instantBook: boolean;
}

export interface ISmartMatchSimilarSearchClickedEventInfo {
  bidID: number;
}
